// extracted by mini-css-extract-plugin
module.exports = {"IndustryLeadingB":"IndustryLeadingB_IndustryLeadingB__uGxgt"};